import React from 'react';
import PropTypes from 'prop-types';
import './CartSidebar.css';

const CartSidebar = ({ isCartOpen, setIsCartOpen, cart, updateQuantity, removeFromCart, totalAmount, setShowCheckout, currency = '₹' }) => {
  return (
    <aside className={`cart-sidebar ${isCartOpen ? 'open' : ''}`} aria-hidden={!isCartOpen}>
      <div className="cart-header">
        <h3>Your Cart ({cart.length})</h3>
        <button
          className="close-btn"
          onClick={() => setIsCartOpen(false)}
          aria-label="Close cart"
        >
          ×
        </button>
      </div>
      <div className="cart-items">
        {cart.length === 0 ? (
          <p className="empty-cart">Your cart is empty</p>
        ) : (
          cart.map((item) => {
            const selectedQty = item.selectedQty || Object.keys(item.product.quantityPricePairs)[0];
            const unitPrice = item.product.quantityPricePairs[selectedQty] ?? 0;
            const displayQty = selectedQty.includes('Pieces') ? selectedQty : 
                              selectedQty.includes('L') || selectedQty.includes('ml') ? selectedQty : `${selectedQty} units`;
            const totalQty = item.multiplier !== undefined ? item.multiplier : 1;
            const itemTotal = unitPrice * totalQty;

            console.log(`Rendering item: ${item.product.name}`, {
              selectedQty,
              quantityPricePairs: item.product.quantityPricePairs,
              unitPrice,
              multiplier: totalQty,
              itemTotal,
            });

            return (
              <div key={`${item.product.id}-${selectedQty}`} className="cart-item">
                <img
                  src={item.product.images?.[0] || 'https://via.placeholder.com/80'}
                  alt={item.product.name}
                  className="cart-item-image"
                />
                <div className="cart-item-details">
                  <h4>{item.product.name}</h4>
                  <p className="unit-info">Unit: {displayQty}</p>
                  <p className="unit-price">Price: {currency}{unitPrice.toFixed(2)}</p>
                  <div className="quantity-controls">
                    <button
                      onClick={() => updateQuantity(item.product.id, selectedQty, -1)}
                      disabled={totalQty <= 1}
                      aria-label={`Decrease quantity of ${item.product.name}`}
                    >
                      -
                    </button>
                    <span>{totalQty}</span>
                    <button
                      onClick={() => updateQuantity(item.product.id, selectedQty, 1)}
                      aria-label={`Increase quantity of ${item.product.name}`}
                    >
                      +
                    </button>
                  </div>
                  <p className="item-total">Total: {currency}{itemTotal.toFixed(2)}</p>
                  <button
                    className="remove-btn"
                    onClick={() => removeFromCart(item.product.id, selectedQty)}
                    aria-label={`Remove ${item.product.name} from cart`}
                  >
                    Remove
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
      {cart.length > 0 && (
        <div className="cart-footer">
          <h4>Total: {currency}{totalAmount.toFixed(2)}</h4>
          <button
            className="checkout-btn"
            onClick={() => setShowCheckout(true)}
            aria-label="Proceed to checkout"
          >
            Checkout
          </button>
        </div>
      )}
    </aside>
  );
};

CartSidebar.propTypes = {
  isCartOpen: PropTypes.bool.isRequired,
  setIsCartOpen: PropTypes.func.isRequired,
  cart: PropTypes.arrayOf(
    PropTypes.shape({
      product: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        images: PropTypes.arrayOf(PropTypes.string),
        quantityPricePairs: PropTypes.objectOf(PropTypes.number).isRequired,
      }).isRequired,
      selectedQty: PropTypes.string,
      multiplier: PropTypes.number,
    })
  ).isRequired,
  updateQuantity: PropTypes.func.isRequired,
  removeFromCart: PropTypes.func.isRequired,
  totalAmount: PropTypes.number.isRequired,
  setShowCheckout: PropTypes.func.isRequired,
  currency: PropTypes.string,
};

CartSidebar.defaultProps = {
  currency: '₹',
};

export default CartSidebar;